// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../fetch.pb.js";
/**
 * FeatureFlagsServiceAPI is used for interacting with feature flags.
 */
export const FeatureFlagsServiceAPI = {
    /**
     * CreateFlag will create a new feature flag.
     */
    CreateFlag(fn, req) {
        return fn(`/feature-flags/v1/flags`, { method: "POST", body: JSON.stringify(req["flag"], fm.replacer) });
    },
    /**
     * DeleteFlag will delete an existing feature flag and unset it on all associated users.
     */
    DeleteFlag(fn, req) {
        try {
            fm.validateUrlParam(req["flagName"], "flagName");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/feature-flags/v1/flags/${req["flagName"]}?${fm.renderURLSearchParams(req, ["flagName"])}`, { method: "DELETE" });
    },
    /**
     * GetFlag retrieves a single flag for a location.
     */
    GetFlag(fn, req) {
        try {
            fm.validateUrlParam(req["name"], "name");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/feature-flags/v1/flags/${req["name"]}?${fm.renderURLSearchParams(req, ["name"])}`, { method: "GET" });
    },
    /**
     * UpdateFlag updates a flag to have a new default value.
     */
    UpdateFlag(fn, req) {
        var _a, _b;
        try {
            fm.validateUrlParam((_a = req["flag"]) === null || _a === void 0 ? void 0 : _a["name"], "flag.name");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/feature-flags/v1/flags/${(_b = req["flag"]) === null || _b === void 0 ? void 0 : _b["name"]}`, { method: "PATCH", body: JSON.stringify(req["flag"], fm.replacer) });
    },
    /**
     * ListFlags will retrieve all flags.
     */
    ListFlags(fn, req) {
        return fn(`/feature-flags/v1/flags?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ListLocationFlags will retrieve flags for a location.
     */
    ListLocationFlags(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/feature-flags/v1/locations/${req["locationId"]}/flags?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    /**
     * SetFlagForLocation will set a single flag for a given location.
     */
    SetFlagForLocation(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["flagName"], "flagName");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/feature-flags/v1/locations/${req["locationId"]}/flags/${req["flagName"]}`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * QueryFlagForLocations gets a list of locations that all have the given flag with the given value
     * Once the period has elapsed, the default value of the flag will be changed to the desired value.
     */
    QueryFlagForLocations(fn, req) {
        try {
            fm.validateUrlParam(req["flagName"], "flagName");
            fm.validateUrlParam(req["value"], "value");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/feature-flags/v1/locations/flags/${req["flagName"]}/${req["value"]}:queryLocations`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * BatchSetFlagForLocations will set a single flag for multiple locations.
     */
    BatchSetFlagForLocations(fn, req) {
        return fn(`/feature-flags/v1/locations/flags:batchCreate`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * SetFlagAll will set a feature flag for all locations.
     */
    SetFlagAll(fn, req) {
        return fn(`/feature-flags/v1/locations/flags:all`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * SetFlagsPercentage will set a percentage of all locations to the given value.
     */
    SetFlagPercentage(fn, req) {
        return fn(`/feature-flags/v1/locations/flags:percentage`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * CreateACLGroup will create a new group for adding feature flags to.
     */
    CreateACLGroup(fn, req) {
        return fn(`/feature-flags/v1/acls`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ListACLGroups will return a list of available ACL groups.
     */
    ListACLGroups(fn, req) {
        return fn(`/feature-flags/v1/acls?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * FlagEnabled will give a response for if a flag is enabled for a location.
     */
    FlagEnabled(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["flagName"], "flagName");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/feature-flags/v1/locations/${req["locationId"]}/flags/${req["flagName"]}:enabled?${fm.renderURLSearchParams(req, ["locationId", "flagName"])}`, { method: "GET" });
    },
    /**
     * ListLocations will return a list of locations that have a given flag set.
     */
    ListLocationsWithFlag(fn, req) {
        try {
            fm.validateUrlParam(req["flagName"], "flagName");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/feature-flags/v1/locations/flags/${req["flagName"]}?${fm.renderURLSearchParams(req, ["flagName"])}`, { method: "GET" });
    },
    /**
     * BatchSetLocation sets multiple flags for a single location.
     */
    BatchSetLocation(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/feature-flags/v1/locations/${req["locationId"]}/flags:batch`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ListEvents will return a list of events.
     */
    ListEvents(fn, req) {
        return fn(`/feature-flags/v1/events?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * SchedulePhasedRollout will schedule a rollout of a feature flag over a given period of time.
     * Once the period has elapsed, the default value of the flag will be changed to the desired value.
     */
    SchedulePhasedRollout(fn, req) {
        return fn(`/feature-flags/v1/locations/flags:schedulePhasedRollout`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
